import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import type { FC } from 'react';

import type { NfcStep } from '..';

const NfcStepContent: FC<NfcStep> = ({ image, alt, step, text }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const smallScreen = useMediaQuery(
    `(max-width:${theme.breakpoints.values.sm + 70}px)`,
  );

  return (
    <Box display="flex" flexDirection="column" alignItems="center" width="100%">
      <Image
        src={image}
        alt={alt}
        width={170}
        height={370}
        priority={step === 1}
        style={{
          height: smallScreen ? '370px' : 'auto',
          width: '170px',
        }}
      />
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width={22}
        height={22}
        mt={2}
        borderRadius="50%"
        bgcolor={theme.vars.palette.primary.main}
        color={theme.vars.palette.common.white}
      >
        <Typography color="inherit" variant="body2">
          {step}
        </Typography>
      </Box>
      <Typography
        mt={1}
        variant="body1"
        fontWeight={500}
        maxWidth={200}
        textAlign="center"
      >
        {t(text)}
      </Typography>
    </Box>
  );
};

export default NfcStepContent;
